import { createSlice } from '@reduxjs/toolkit';
import dayjs from 'dayjs';

const dateFormat = 'DD.MM.YYYY';
const now = dayjs();

const init = {
  precision_search: false,
  //date_range: ['01.01.2000', now.format(dateFormat)],
  date_range: null,
  sortBy: '_score-desc',
  //collapsed: ['1'], //default open
  collapsed: [], // default closed
};

const searchFilterSlice = createSlice({
  name: 'searchFilter',
  initialState: init,
  reducers: {
    saveFilter: (state, action) => action.payload,
    clearFilter: () => init,
  },
});

export const { saveFilter, clearFilter } = searchFilterSlice.actions;
export default searchFilterSlice.reducer;
